import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import BackGroundImage from './web/BackGroundImage';
import AdmnistrationWeb from '../../blog/components/AdmnistrationWeb';
import PhotoGallery from './web/PhotoGallery.jsx';
import EventCalendar from './web/EventCalendar.jsx';
import BriefsManagement from './web/BriefsManagement.jsx';
import PhotoWeekManagement from './web/PhotoWeekManagement.jsx';
import QuickLinkManagement from './web/QuickLinkManagement.jsx';
import ContactLinkManagement from './web/ContactLinkManagement.jsx';
import GalleryDirectionManagement from './web/GalleryDirectionManagement.jsx';
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// function a11yProps(index) {
//   return {
//     id: `simple-tab-${index}`,
//     'aria-controls': `simple-tabpanel-${index}`,
//   };
// }

export default function WebAdminToolBar() {
  const [value, setValue] = React.useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} aria-label="basic tabs example">
                <Tab label="admnistration" onClick={() => setValue(0)}/>
                <Tab label="Publicites" onClick={() =>  setValue(1)} />
                <Tab label="Galleries photos" onClick={() =>  setValue(2)} />
                <Tab label="Calendrier des evenements" onClick={() =>  setValue(3)} />
                <Tab label="Espace de brèves" onClick={() =>  setValue(4)} />
                <Tab label="Liens de partenaires" onClick={() =>  setValue(5)} />
                <Tab label="Nos Contacts" onClick={() =>  setValue(6)} />
                <Tab label="Les Directeurs" onClick={() =>  setValue(7)} />
                {/* <Tab label="Photos de la semaine" onClick={() =>  setValue(5)} /> */}
        </Tabs>
      </Box>
        <Box>
          <TabPanel value={value} index={0}>
            <AdmnistrationWeb/>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <BackGroundImage />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <PhotoGallery />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <EventCalendar />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <BriefsManagement />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <QuickLinkManagement />
          </TabPanel>
          <TabPanel value={value} index={6}>
            <ContactLinkManagement />
          </TabPanel>
          <TabPanel value={value} index={7}>
            <GalleryDirectionManagement />
          </TabPanel>
          {/* <TabPanel value={value} index={5}>
            <PhotoWeekManagement />
          </TabPanel> */}

        </Box>
    </Box>
  );
}
